import en from './en-us';
import ch from './ch-cn';

export default {
    ...en,
    ...ch,
}